import { Component, OnInit,ElementRef,  ViewChild, Injectable, OnDestroy} from '@angular/core';
import {CdkDragDrop,  moveItemInArray, transferArrayItem, CdkDragEnd, CdkDragStart} from '@angular/cdk/drag-drop';
import {GraphService} from '../../services/graph.service'
import * as firebase from 'firebase'
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import {
  trigger,
  state,
  style,
  animate,
  transition,
  // ...
} from '@angular/animations';

import { FormGroup, FormBuilder, Validators } from '@angular/forms';

import { AuthService } from '../../services/auth.service';
import { DateService } from '../../services/date.service';



@Component({
  selector: 'app-profil',
  animations: [
    trigger('dragDrop', [
      // ...
      state('on', style({
        border: 'solid rgb(228, 106, 153)'
      })),
      state('out', style({
        border: 'dashed rgb(150, 150, 150) '
      })),
      transition('on => out', [
        animate('0.1s')
      ]),
      transition('out => on', [
        animate('0.1s')
      ]),
    ]),
  ],
  templateUrl: './profil.component.html',
  styleUrls: ['./profil.component.scss']
})
export class ProfilComponent implements OnInit {

 
  name : string;
  admin : any;
  service : string;

  constructor(private graphService : GraphService, 
    private formBuilder: FormBuilder,
    private authService: AuthService,
    private dateService : DateService) { }
setGraph
active:string[] = []
setDate:boolean = false
right:number = -250
setting=false

inactive:string[] =[]

user = firebase.auth().currentUser.uid;
ref 
toSave:string
toSaveInac:string
Auth
placeTop:number
placeLeft:number
deplacement = false
initialPosition :any 
position = { ...this.initialPosition };
offset = { x: 0, y: 0 };
comp
droppable = false
dragging = false
date_start
date_end
@ViewChild('sidebar') inactiveGraph: ElementRef;
@ViewChild('main') activeGraph: ElementRef;
@ViewChild('setInactive') selectInac: ElementRef;
@ViewChild('pos') pos : ElementRef
source:any[] = []
type:any[] = []
compteur:number = 0
signUpForm: FormGroup;
isAuth
page = "Profil"
shopId
  

  async ngOnInit(){
    this.setGraph = "hide"
    localStorage.setItem('page','Perso')
    localStorage.setItem('realTime', '0')
    let varAdmin;
    var objet = this
    this.name = this.authService.getName();
    this.authService.isAdmin().then((name)=>{ this.admin = name })
    
      this.ref = firebase.database().ref('PageConfig/Profil/'+this.user+'/Charts')
    
      firebase.auth().onAuthStateChanged(
        (user)=>{
        if(user){
        this.authService.isAdmin().then((name)=>{
        this.admin = name 
        }).then(()=>{
        var id = firebase.auth().currentUser.uid;
        var ref = firebase.database().ref("users");
        ref.orderByKey().equalTo(id).on("child_added", (snapshot) => { 
          if(snapshot.val().actif == true){
            this.isAuth = true;
          }
        });
        })
        
        } else {
        this.admin = false;
        this.isAuth = false;
        }
        }
        )
        
        firebase.database().ref('PageConfig/Profil/'+this.user).once('value',(snapshot)=>{
        this.date_start = localStorage.getItem('date_start');
        this.date_end = localStorage.getItem('date_end')
        })
        this.setView()
        this.dateService.changeVar.subscribe(message => this.myVar = message);
  }

  private _myVar: string = "";

  get myVar(): string {
      return this._myVar;
  }
  set myVar(value: string) {
      if (value !== this._myVar) {
          this._myVar = value;
          this.doSomething();
      }
  }

doSomething(){
this.dateUpdate()
this.setView()
this.showLibrary()
}


  ngOnDestroy(){
    clearInterval(this.Auth);
    }

    showLibrary() {

      this.setGraph = localStorage.getItem('settings');
      if (this.setGraph == 'show') {
        this.right = 0
        this.setting =true
      }
      else {
        this.setting =false
        this.right = -250
      }
    }
    placeGraph(e){
    
    if (this.deplacement == true && this.droppable == true) {
    this.placeLeft =  e.offsetX
    this.placeTop = e.offsetY

    this.ref = 'PageConfig/Profil/'+this.user+'/Charts/'+this.comp;
      //Suppression du dernier caractère qui créait un problème inconnu
    // this.ref = this.ref.slice(0,-1);
    // this.ref = firebase.database().ref(this.ref);
    firebase.database().ref(this.ref).update({
    top : this.placeTop + this.offset.y,
    left : this.placeLeft + this.offset.x,
    actif : true,
    height : 200,
    width : 400,
    })
    }
    
    }
    drop(event: CdkDragDrop<string[]>) {
    if (event.previousContainer === event.container) {
    moveItemInArray(event.container.data, event.previousIndex, event.currentIndex); 
    } else {
    if (this.droppable == true) {
    transferArrayItem(event.previousContainer.data, event.container.data, event.previousIndex, event.currentIndex);
    this.comp = event.item.element.nativeElement.innerText
    
    this.deplacement = true;
    this.toSave = ""
    this.toSaveInac = ""
    this.active.forEach(element => {
    this.toSave += element+'_'
    });
    this.inactive.forEach(element =>{
    this.toSaveInac += element+'_'
    })
    this.graphService.saveGraphs(this.toSave, this.toSaveInac, this.page);
    this.setView()
    }
    
    
    }
    }
    
    dragStart($event: CdkDragStart) {
    this.dragging = true
    }
    dragEnd($event: CdkDragEnd) {
    this.dragging = false
    }
    
    async setView(){


      firebase.database().ref('PageConfig/Profil/'+this.user+'/Charts').orderByKey().once("value", (snapshot) => {
        this.active = snapshot.val().actifs.split("_")
        this.active = this.active.filter(word => word.length > 1)
        this.inactive = snapshot.val().inactifs.split("_")
        this.inactive = this.inactive.filter(word => word.length > 1)
      }).then(()=>{
        this.inactive.forEach((element) => {
          firebase.database().ref('PageConfig/Profil/'+this.user+'/Charts/'+element+'/config').orderByKey().once("value", (snapshot) => {
            this.source[element] = snapshot.val().source
            this.type[element] = snapshot.val().type
          })
        });
      })
    
    }
    
    intoDrop(e){
    this.droppable = true
    }
    outDrop(e){
    this.droppable = false;
    }
    
    
    dateUpdate(){
      this.compteur = this.compteur+1
      this.date_start = localStorage.getItem('date_start');
      this.date_end = localStorage.getItem('date_end'); 
    }
    tt = 0
      myFunction () {
        this.dateService.changeMyVar(' '+this.tt++); // update variable
      }

      getSource(graph){
        var source = this.source[graph]
          if(source =='GA'){
            return "https://ynoki.fr/wp-content/uploads/2019/02/google-analytics-logo.png";
          }else{
            return 'https://upload.wikimedia.org/wikipedia/fr/7/7d/Prestashop-logo.png';
          }
      }

      getType(graph){
        var type = this.type[graph]
        if(type == 'number'){
          return true
        }
        else{
          return false
        }
      }
}
